<script lang="ts">
	import { onMount, onDestroy } from 'svelte'
	import ContextMenu from './ContextMenu.svelte'

	interface Props {
		x: number
		y: number
		show: boolean
		options: any[]
	}

	let { x, y, show, options = [] }: Props = $props()
	let element: HTMLDivElement

	onMount(() => {
		// Create a container and append it to document.body
		element = document.createElement('div')
		document.body.appendChild(element)
	})

	onDestroy(() => {
		if (element && document.body.contains(element)) {
			document.body.removeChild(element)
		}
	})
</script>

<!-- Render the container always; hide its content when show is false -->
<div
	bind:this={element}
	style="position: fixed; left: {x}px; top: {y}px; z-index: 999; {show ? '' : 'display: none;'}"
>
	<ContextMenu {x} {y} {options} />
</div>
